import { useEffect, useState } from 'react';
let id = 0;
const genId = () => ++id;
export const useUniqueId = prefix => {
  const [id, setId] = useState(null);
  useEffect(() => {
    if (id === null) {
      setId(genId());
    }
  }, [id]);
  return "".concat(prefix, "-").concat(id);
};